// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","overflow_anchor_none":"kRq8YS","AniFadeIn":"a12hgD","AniFadeOut":"HALG_5","AniRotate":"ElvO5C","AniPlaceholderFadeOut":"daa2SJ"};